export default IconBounceRight => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bounce-right" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 15.5c3 -1 5.5 -.5 8 4.5c.5 -3 1.5 -5.5 3 -8" />
  <path d="M18 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z" />
</svg>`;